<template>
  <sub-nav>
    <b-nav-item key="action"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/action">行動宣言</router-link>
    </b-nav-item>
    <b-nav-item key="makeevent"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/makeevent">イベント作成</router-link>
    </b-nav-item>
    <b-nav-item key="spot"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/spot">スポット</router-link>
    </b-nav-item>
    <b-nav-item key="myworld" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/myworld">異世界</router-link>
    </b-nav-item>
  </sub-nav>
</template>

<script>
import SubNav from './SubNav'
export default {
  name: 'action-nav',
  components: { SubNav }
}
</script>

<style lang="scss" scoped>
</style>
